import type { CommonEditorTab } from "./reducers";
import type { NavbarPagesTabContentFragment } from "../client/generated";
import { useTranslation } from "react-i18next";
import { NavbarTabContent } from "../shell/NavbarTabContent";
import { SidebarDivider } from "../shell/SidebarDivider";
import { PageThumbnail } from "../pages/PageThumbnail";
import { PagePagination } from "../pages/PagePagination";
import { ScrollArea } from "@acdc2/ui/components/scroll-area";
import { PageIssuesBadge } from "../issues/PageIssuesBadge";

type Props = {
  fragment: NavbarPagesTabContentFragment;
};

export function NavbarPagesTabContent({ fragment }: Props) {
  const { t } = useTranslation();

  return (
    <NavbarTabContent
      value={"pages" satisfies CommonEditorTab}
      title={t("NavbarPagesTabContent.title")}
    >
      <ScrollArea className="@container flex-1">
        <div className="p-4 grid gap-4 grid-cols-1 @xs:grid-cols-2 @lg:grid-cols-3 @2xl:grid-cols-4 @4xl:grid-cols-5">
          {fragment.document.pages.pages.map((page) => (
            <PageThumbnail
              key={page.id}
              fragment={page}
              highlight={page.id === fragment.id}
            >
              <PageIssuesBadge fragment={page} />
            </PageThumbnail>
          ))}
        </div>
      </ScrollArea>
      <div>
        <SidebarDivider />
        <PagePagination key={fragment.id} fragment={fragment} />
      </div>
    </NavbarTabContent>
  );
}
